import React from 'react'
import Logo from './logo'
import { HorizontalStack } from '@ztechapps/webui.util'

export const LogoWithName = () => {
  return (
    <a href="/">
      <HorizontalStack>
        <Logo />
        <h3>Payme</h3>
      </HorizontalStack>
    </a>
  )
}
